import React from "react";
import { useParams } from "react-router-dom";

import SidebarItem from "components/SidebarItem";
import CommodityShowSmall from "components/CommodityShowSmall";

export default function DeliveryItem({
  currentStoreData,
  store,
  ...extraProps
}) {
  const selected =
    currentStoreData && currentStoreData.client_id === store.client_id;
  const params = useParams();
  const isAdhoc = store.meta?.is_adhoc === true;
  const title = (
    <>
      {`Waybill ${store.meta?.waybill_no}`}
      {isAdhoc && <span className="adhoc-tag">AD-HOC</span>}
    </>
  );
  return (
    <SidebarItem
      {...extraProps}
      store={store}
      selected={selected}
      id={store.client_id}
      key={store.client_id}
      title={title}
      to={`/school/${params.schoolId}/deliveries/${store.client_id}`}
    >
      <CommodityShowSmall commodities={store?.stock_events} />
    </SidebarItem>
  );
}
